import { render, staticRenderFns } from "./participantsDropdown.vue?vue&type=template&id=180181b3&scoped=true"
import script from "./participantsDropdown.vue?vue&type=script&lang=js"
export * from "./participantsDropdown.vue?vue&type=script&lang=js"
import style0 from "./participantsDropdown.vue?vue&type=style&index=0&id=180181b3&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "180181b3",
  null
  
)

export default component.exports